import { createReducer, on } from '@ngrx/store';
import { TreeNode } from 'primeng/api';
import { loadMenu, loadMenuSuccess, loadMenuFailure, toggleExpanded, selectNode, refreshMenu } from './MenuAction';

export interface MenuState {
	nodes: TreeNode[];
	expandedKeys: { [key: string]: boolean };
	selectedKey?: string;
	loading: boolean;
	error?: any;
}

export const initialMenuState: MenuState = {
	nodes: [],
	expandedKeys: {},
	selectedKey: undefined,
	loading: false,
	error: undefined
};

export const MenuReducer = createReducer(
	initialMenuState,
	on(loadMenu, (state) => ({ ...state, loading: true, error: undefined })),
	on(loadMenuSuccess, (state, { nodes }) => ({ ...state, nodes, loading: false })),
	on(loadMenuFailure, (state, { error }) => ({ ...state, loading: false, error })),
	on(toggleExpanded, (state, { key, expanded }) => ({
		...state,
		expandedKeys: { ...state.expandedKeys, [key]: expanded }
	})),
	on(selectNode, (state, { key }) => ({ ...state, selectedKey: key })),
	on(refreshMenu, (state) => ({ ...state, loading: true }))
);

